(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["review-form-fields"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const stars = document.querySelectorAll(".review-form__fields__star");
    const starsInput = document.querySelector('#stars');
    let selectedRating = 0;

    function updateStars(rating) {
      stars.forEach((star) => {
        const value = parseInt(star.dataset.value, 10);

        if (value <= rating) {
          star.classList.add("active");
        } else {
          star.classList.remove("active");
        }

        star.classList.remove("hover");
      });
    }

    stars.forEach((star) => {
      star.addEventListener("click", function () {
        selectedRating = parseInt(this.dataset.value, 10);
        starsInput.value = selectedRating;
        updateStars(selectedRating);
      });

      star.addEventListener("mouseenter", function () {
        const hoverRating = parseInt(this.dataset.value, 10);
        stars.forEach((s) => {
          const value = parseInt(s.dataset.value, 10);
          if (value <= hoverRating) {
            s.classList.add("hover");
          } else {
            s.classList.remove("hover");
          }
        });
      });

      star.addEventListener("mouseleave", function () {
        stars.forEach((s) => s.classList.remove("hover"));
        updateStars(selectedRating);
      });
    });

    document.querySelector('.review-form__fields__submit').addEventListener('click', function () {

      let btn = this;
      let formData = new FormData();

      btn.setAttribute('disabled', 'disabled');

      formData.set('rating', starsInput.value);
      
      formData.set('body', document.querySelector('#body').value);
      
      formData.set('title', document.querySelector('#title').value);
      
      formData.set('name', document.querySelector('#name').value);
      
      formData.set('email', document.querySelector('#email').value);

      formData.set('lang', btn.getAttribute('data-lang'));

      formData.set('photo', document.querySelector('#photo').files[0]);

      fetch('https://activecampaign.yourst.agency/api/judge-me', {
        method: "POST",
        body: formData,
      })
        .then((resp) => resp.json())
        .then((data) => {
          if (data.success) {
            window.location.href = `${window.location.origin}/pages/thank-you`
          } else {
            btn.removeAttribute('disabled');
            document.querySelectorAll('.field-error').forEach(el => el.remove());

              Object.entries(data.errors).forEach(([field, message]) => {
                const fieldEl = document.getElementById(field);
                if (fieldEl) {
                  const error = document.createElement('p');
                  error.className = 'field-error';
                  error.style.color = '#d62828';
                  error.textContent = Array.isArray(message) ? message[0] : message;
                  fieldEl.insertAdjacentElement('afterend', error);
                }
            });
            
            if (document.querySelector('.field-error')) {
              document.querySelector('.field-error').scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
        });
    });
    
  });
  } catch(e) { console.error(e); }
})();

})();
